import {DOCUMENT_TYPES, TaxProfileSubsection} from 'src/constants/constants';
import {DerivedQueryType} from 'src/store/queries/queries.reducer';
export enum QueryFilterKeys {
  docType = 'docType',
  subsection = 'subsection',
  highValueDeduction = 'highValueDeduction',
  userTaxProfile = 'userTaxProfile',
  general = 'general',
  reviewEsign = 'reviewEsign',
  distributeDeductions = 'distributeDeductions',
  taxFilingFeedback = 'taxFilingFeedback',
  personalReturnApprovedFromIRS = 'personalReturnApprovedFromIRS',
}

export type QueryFilterType =
  | {
      [QueryFilterKeys.docType]: DOCUMENT_TYPES;
    }
  | {
      [QueryFilterKeys.subsection]: TaxProfileSubsection;
    }
  | {
      [QueryFilterKeys.highValueDeduction]: DerivedQueryType.HIGH_VALUE_DEDUCTION;
    }
  | {
      [QueryFilterKeys.userTaxProfile]: DerivedQueryType.TAX_PROFILE;
    }
  | {
      [QueryFilterKeys.general]: DerivedQueryType.GENERAL;
    }
  | {
      [QueryFilterKeys.reviewEsign]: DerivedQueryType.REVIEW_ESIGN;
    }
  | {
      [QueryFilterKeys.distributeDeductions]: DerivedQueryType.DISTRIBUTE_DEDUCTIONS;
    }
  | {
      [QueryFilterKeys.taxFilingFeedback]: DerivedQueryType.TAX_FILING_FEEDBACK;
    }
  | {
      [QueryFilterKeys.personalReturnApprovedFromIRS]: DerivedQueryType.PERSONAL_RETURN_ACCEPTED_BY_IRS;
    };

export enum USER_QUERIES_URL_SEARCH_PARAMS {
  RETURN_ID = 'returnId',
  RETURN_TYPE = 'returnType',
}
